<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-row no-gutters>
					<v-col cols="4" @click="locumViewAvailability(set)">
						<v-skeleton-loader v-if="!avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>

						<v-list-item-avatar v-else-if="avatar && avatar != 'no-avatar'" width="60" height="60">
							<v-img :src="avatar"></v-img>
						</v-list-item-avatar>

						<v-list-item-avatar v-else width="60" height="60">
							<v-img :src="no_avatar"></v-img>
						</v-list-item-avatar>
					</v-col>
					<v-col cols="8">
						<div @click="locumViewAvailability(set)">
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-title class="secondary--text font-weight-bold">{{ set.request.name }}</v-list-item-title>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-title class="subtitle-2 font-weight-bold"
										>{{ dateFormattedMomentjs(set.offer.date) }} - {{ dateFormattedMomentjs(set.offer.end_date) }}</v-list-item-title
									>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold"
										>{{ start_time }} - {{ end_time }}</v-list-item-subtitle
									>

									<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-subtitle class="primary--text lighten-1 font-weight-bold">#{{ set.offer.offer_code }}</v-list-item-subtitle>
								</v-col>
							</v-row>
						</div>
						<v-row v-if="showMessageValid(set.offer.end_date)" no-gutters>
							<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
								<v-btn class="white--text button-rounded mt-2" :height="25" color="accent" @click="openMessageDialog()">
									<span style="font-size: 12px">Message</span>
								</v-btn>
							</v-badge>
						</v-row>
					</v-col>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="locumViewAvailability(set)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';
import axios from 'axios';

export default {
	name: 'ApplicationsReceivedCard',
	components: {},
	props: {
		set: { type: Object, required: true },
	},
	data: () => ({
		avatar: false,
		no_avatar: store.getters.noAvatar,
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),
	watch: {},
	created() {},
	async mounted() {
		await this.getUnreadMessageCount();
		this.getAvatar();
		this.getTimes();
	},
	beforeDestroy() {},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		async locumViewAvailability(set) {
			store.dispatch('setPracticeOfferSelected', set);

			const { start_time, end_time, lunch, notes, id: offerId, profession, rates, experience, skills, request_dates } = set.offer;
			const { booking_dates, booking_dates_times, id } = set.request;

			const booking = { start_time, end_time, lunch, notes, booking_dates, booking_dates_times, id: offerId, profession, rates, experience, skills, request_dates };
			store.dispatch('setPracticeViewingLocum', [{ id, booking, source: 'viewLocumApplication' }]);
			bus.$emit('change-context', 'view-locum-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		async getAvatar() {
			if (!this.avatar) {
				try {
					let response = await axios.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.set.request.id, { headers: { Authorization: store.getters.jwtToken } });
					this.avatar = 'data:image/png;base64,' + response.data.data;
				} catch (err) {
					this.avatar = 'no_avatar';
				}
			}
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.set.offer.start_time;
			this.end_time = this.set.offer.end_time;
			for (let index = 0; index < this.set.offer.request_dates.length; index++) {
				if (
					moment(this.set.offer.request_dates[index].start_time).format('HH:mm') !== this.set.offer.start_time ||
					moment(this.set.offer.request_dates[index].end_time).format('HH:mm') !== this.set.offer.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},

		openMessageDialog() {
			const sentByID = this.set.offer.company.id;
			let receiverDetails = {
				id: this.set.request.id,
				name: this.set.request.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
			bus.$emit('refresh-total-unread-message-count');
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.set.offer.company.id,
				sentByID: this.set.request.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
